export default {
  'pages.layouts.userLayout.title': 'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  // Login Page
  'error.userNotFound': '错误的邮箱帐号或密码。',
  'pages.registration.success': '注册成功',
  'pages.login.twofactor': '第二因素身份验证',
  'pages.login.twofactor.required': '请输入您的身份验证器应用程序中的 六 位数代码',
  'pages.login.resend.confirmation': '重发确认邮件',
  'pages.login.verification.success': '验证链接已发送至您的邮箱！',
  'pages.login.verification.error': '您还没有验证您的电子邮件！',
  'pages.login.verification.resend': '您想重新发送电子邮件确认链接吗？',
  'pages.login.verification.resend.cancel': '取消',
  'pages.login.form.email.validation.required': '电子邮件为必填项',
  'pages.login.form.email.validation.email': '电子邮件地址无效！',
  'pages.login.form.email.placeholder': '电子邮件',
  'pages.login.form.password.placeholder': '密码',
  'pages.login.verification.resend.button.time': '重发 ({countdown}s)',
  'pages.login.verification.resend.button': '重发',
  // Profile Page
  'profile.changePassword.success': '密码修改成功！',
  'profile.changePassword.field.old.label': '旧密码',
  'profile.changePassword.field.old.required': '输入您的旧密码',
  'profile.changePassword.field.new.label': '新密码',
  'profile.changePassword.field.new.required': '输入您的新密码',
  'profile.changePassword.field.new.min': '密码长度必须至少为 8 个字符',
  'profile.changePassword.field.new.minUpperCase': '密码必须包含至少一个大写字母',
  'profile.changePassword.field.new.minLowerCase': '密码必须包含至少一个小写字母',
  'profile.changePassword.field.new.minNumber': '密码必须包含至少一个数字',
  'profile.changePassword.field.confirm.label': '确认密码',
  'profile.changePassword.field.confirm.required': '请再次重复新密码！',
  'profile.changePassword.button': '更改密码',
  // User Profile Page
  'userProfile.userInfo.title': '用户信息',
  'userProfile.userInfo.fullName': '全名',
  'userProfile.userInfo.email': '电子邮件',
  'userProfile.userInfo.phone': '电话',
  'userProfile.userInfo.twofa.status.enabled': '启用',
  'userProfile.userInfo.twofa.setup': '设置',
  // Dashboard Page
  'dashboard.walletBalance': '钱包余额',
  'dashboard.hotWalletBalance': '热钱包余额',
  'dashboard.hotWalletBalance.fetchFailed': '获取失败',
  'dashboard.message.walletFetch.error': '获取钱包数据失败',
  'dashboard.feeBalance': '手续费余额',
  'dashboard.analytics.title': '手续费统计',
  'dashboard.analytics.period.week': '7 天',
  'dashboard.analytics.period.month': '31 天',
  'dashboard.analytics.totalFee': '手续费总额',
  'dashboard.analytics.daily.title': '单日手续费',
  'dashboard.analytics.daily.feeTotal': '手续费',
  'dashboard.analytics.daily.txCount': '交易数',
  'dashboard.todayFee': '手续费',
  'dashboard.dataNotAvailable': '数据缺失',
  'dashboard.section.currentBalances': '当前余额',
  'dashboard.section.analytics': '统计分析',
  'dashboard.chart.tooltip.feeTotal': '手续费',
  // Hot Wallet page
  'hotWallet.table.column.lowBalanceNotificationAmount': 'USDT 低余额通知金额',
  'hotWallet.modal.lowBalance.title': '设置低余额通知金额（USDT）',
  'hotWallet.modal.lowBalance.input': '输入金额',
  'hotWallet.modal.minTrigger.title': '最低触发归集金额',
  'hotWallet.modal.minTrigger.input': '输入金额',
  'hotWallet.page.fetch.error': '获取热钱包数据失败',
  'hotWallet.page.balance.rpcError': '获取余额失败（RPC 错误）',
  'hotWallet.page.minAmount.success': '最低通知金额更新成功！',
  'hotWallet.page.minAmount.error': '更新最低通知金额失败',
  'hotWallet.page.consolidate.success': '正在归集资金,请耐心的等待。您可以在归集页面中查看状态。',
  'hotWallet.page.consolidateFee.success':
    '正在归集 {selectWalletLength}/{totalWalletLength}。请等待归集过程完成后再启动下一批',
  'hotWallet.page.consolidate.validation': '请输入金额',
  'hotWallet.page.table.column.address': '钱包地址',
  'hotWallet.page.table.column.balance': '可用燃料费余额',
  'hotWallet.page.table.column.usdtBalance': 'USDT 余额',
  'hotWallet.page.table.column.network': '网络',
  'hotWallet.page.table.column.action': '操作',
  'hotWallet.page.table.action.collectFee': '归集手续费',
  'hotWallet.page.table.action.collectFund': '归集资金',
  'hotWallet.page.table.action.freeze': '冻结',
  'hotWallet.page.table.action.unfreeze': '解冻',
  'hotWallet.page.table.action.transfer': '划转',
  'hotWallet.page.transfer.success': '转账发起, 请在提现记录查看转账状态',
  'hotWallet.page.transfer.error': '转账发起失败',
  'hotWallet.modal.transfer.label.address': '接收地址',
  'hotWallet.modal.transfer.placeholder.address': '请输入接收地址',
  'hotWallet.modal.transfer.validation.addressRequired': '请输入转账地址',
  'hotWallet.modal.transfer.label.amount': '转账金额',
  'hotWallet.modal.transfer.placeholder.amount': '请输入转账金额',
  'hotWallet.modal.transfer.validation.amountRequired': '请输入转账金额',
  'hotWallet.modal.transfer.validation.amountMaxFourDecimals': '转账金额最多支持 4 位小数',
  'hotWallet.modal.transfer.label.twoFA': '2FA 验证码',
  'hotWallet.modal.transfer.placeholder.twoFA': '请输入 2FA 验证码',
  'hotWallet.modal.transfer.error.invalidTwoFA': '验证码错误，请重试。',
  'hotWallet.modal.transfer.validation.twoFARequired': '请输入 2FA 验证码',
  'hotWallet.modal.transfer.validation.twoFALength': '2FA 验证码必须为 6 位数字',
  'hotWallet.modal.transfer.title': '划转',
  'hotWallet.modal.transfer.hint.twoFA': '如若未设置, 请在用户设定页面设置',

  // Sub Users Page
  'subUsers.title': '子账号',
  'subUsers.table.column.fullName': '全名',
  'subUsers.table.column.email': '电子邮件',
  'subUsers.table.column.role': '角色',
  'subUsers.table.column.action': '操作',
  'subUsers.table.column.permissions': '权限',
  'subUsers.action.delete.success': '子账号删除成功',
  'subUsers.action.delete.confirm': '您确定要删除该子账号吗？',
  'subUsers.action.delete.confirm.cancel': '不',
  'subUsers.action.delete.confirm.ok': '是的',
  'subUsers.action.delete.error': '删除子账号失败',
  'subUsers.action.fetch.error': '获取子账号失败',
  'subUsers.action.removeRevoke': '添加权限',
  'subUsers.action.revoke': '取消权限',
  'subUsers.action.permission.ReadTransaction': '读取交易',
  'subUsers.action.permission.CreateTransaction': '创建交易',
  'subUsers.action.permission.UpdateTransaction': '更新交易',
  'subUsers.action.permission.DeleteTransaction': '删除交易',
  'subUsers.action.permission.ExportTransaction': '导出交易',
  'subUsers.action.permission.ReadDashboard': '读取仪表盘',
  'subUsers.action.permission.ReadFeeBalance': '读取手续费余额',
  'subUsers.action.permission.CreateConsolidation': '发起归集',
  'subUsers.action.permission.ReadConsolidation': '读取归集',
  'subUsers.action.permission.CreateConsolidationFee': '发起归集手续费',
  'subUsers.action.permission.ReadConsolidationFee': '读取归集手续费',
  'subUsers.action.permission.ReadWallet': '读取钱包',
  'subUsers.action.permission.ReadHotWallet': '读取热钱包',
  'subUsers.action.permission.ReadHotWalletWithdrawals': '读取热钱包提现',
  'subUsers.action.permission.InitiateHotWalletWithdrawals': '发起热钱包提现',
  'subUsers.action.permission.ReadFeeHotWallet': '读取手续费热钱包',
  'subUsers.action.permission.ReadFeeHotWalletWithdrawals': '读取手续费热钱包提现记录',
  'subUsers.action.permission.InitiateFeeHotWalletWithdrawals': '发起手续费热钱包提现',
  'subUsers.action.permission.WriteHotWalletFreezeOrUnFreeze': '冻结/解冻热钱包',
  'subUsers.action.permission.ReadWithdrawRequest': '读取提现请求',
  'subUsers.action.permission.WriteWithdrawRequest': '批准或拒绝提现请求',
  'subUsers.action.permission.ResendTransactionWebhook': '重发充值回调',
  'subUsers.action.permission.ResendWithdrawWebhook': '重发提现回调',

  // Consolidate Logs Page
  'consolidateLogs.status.pending': '待处理',
  'consolidateLogs.status.success': '成功',
  'consolidateLogs.status.fail': '失败',
  'consolidateLogs.status.rejected': '审核拒绝',
  'consolidateLogs.table.column.date': '日期',
  'consolidateLogs.table.column.txHash': 'TX Hash',
  'consolidateLogs.table.column.fromAddress': '发件人地址',
  'consolidateLogs.table.column.toAddress': '收件人地址',
  'consolidateLogs.table.column.amount': '金额',
  'consolidateLogs.table.column.batchId': '批次编号',
  'consolidateLogs.table.column.status': '状态',
  'consolidateLogs.filters.column.all': '全部',
  'consolidateLogs.search.placeholder': '搜索归集日志',
  // Transactions Page
  'transactions.table.title': '最近交易 ',
  'transactions.table.tx': '交易',
  'transactions.table.id': 'ID',
  'transactions.table.from': '发送方',
  'transactions.table.to': '接收方',
  'transactions.table.network': '网络',
  'transactions.table.inOut': '进 | 出',
  'transactions.table.amount': '金额',
  'transactions.table.amountAfterFee': '扣费后金额',
  'transactions.table.feeAmount': '手续费金额',
  'transactions.table.timestamp': '时间戳',
  'transactions.table.transferDirection.in': '进',
  'transactions.table.transferDirection.out': '出',
  'transactions.table.transferDirection.all': '全部',
  'transactions.table.transferDirection.placeholder': '转账方向',
  'transactions.table.export': '导出',
  'transactions.table.failedToFetch': '获取交易失败',
  'transactions.table.invalidDate': '无效日期',
  'transactions.table.notAvailable': '不可用',
  'transactions.table.fromLabel': '发送方:',
  'transactions.table.toLabel': '接收方:',

  // Transaction Search
  'transactions.search.column.general': '所有字段',
  'transactions.search.column.txHash': '交易哈希',
  'transactions.search.column.from': '发送地址',
  'transactions.search.column.to': '接收地址',
  'transactions.search.column.id': '交易ID',
  'transactions.search.placeholder.txHash': '搜索交易哈希...',
  'transactions.search.placeholder.from': '搜索发送地址...',
  'transactions.search.placeholder.to': '搜索接收地址...',
  'transactions.search.placeholder.id': '搜索交易ID...',
  'transactions.search.clear': '清除搜索',
  'transactions.search.noResults': '未找到符合搜索条件的交易',
  'transactions.search.loading': '正在搜索交易...',
  'transactions.search.error': '搜索失败，请重试。',

  // Wallets Page
  'wallets.table.column.address': '钱包地址',
  'wallets.table.column.name': '名称',
  'wallets.table.column.usdtBalance': 'USDT 余额',
  'wallets.table.column.reference': '参考',
  'wallets.table.column.network': '网络',
  'wallets.table.column.balanceAfterFee': 'USDT 余额(含手续费)',
  'wallets.table.column.accumFees': '累计手续费',
  'wallets.table.search.placeholder': '按钱包搜索',

  // Withdraw Logs Page
  'withdrawLogs.status.pending': '待处理',
  'withdrawLogs.status.success': '成功',
  'withdrawLogs.status.fail': '失败',
  'withdrawLogs.status.rejected': '审核拒绝',
  'withdrawLogs.table.column.date': '日期',
  'withdrawLogs.table.column.txHash': 'TX Hash',
  'withdrawLogs.table.column.fromAddress': '发件人地址',
  'withdrawLogs.table.column.toAddress': '收件人地址',
  'withdrawLogs.table.column.network': '网络',
  'withdrawLogs.table.column.token': '代币',
  'withdrawLogs.table.column.amount': '金额',
  'withdrawLogs.table.column.reference': '参考',
  'withdrawLogs.table.column.status': '出款状态',
  'withdrawLogs.table.column.isNotified': '回调状态',
  'withdrawLogs.table.column.actionType': '操作类型',
  'withdrawLogs.table.column.value.actionType.MANUAL': '手动',
  'withdrawLogs.table.column.value.actionType.API': 'API',
  'withdrawLogs.table.button.resendWebhook': '重新发送回调',
  'withdrawLogs.resend.success': '重新发送回调成功',
  'withdrawLogs.resend.error': '无法重新发送 webhook。',
  'withdrawLogs.table.column.actions': '操作',

  // Withdraw Logs Search
  'withdrawLogs.search.placeholder.txHash': '搜索交易哈希...',
  'withdrawLogs.search.placeholder.from': '搜索发件人地址...',
  'withdrawLogs.search.placeholder.to': '搜索收件人地址...',
  'withdrawLogs.search.clear': '清除搜索',

  // Withdraw Logs Filters
  'withdrawLogs.filter.status': '出款状态',
  'withdrawLogs.filter.network': '网络',
  'withdrawLogs.filter.token': '代币',
  'withdrawLogs.filter.actionType': '操作类型',

  // Withdraw Logs Export
  'withdrawLogs.export.limit.note': '导出仅限最多 3 个月。请缩小日期范围。',
  'withdrawLogs.export.no_data': '当前筛选条件下无数据可导出。',
  'withdrawLogs.export.max_records': '未应用筛选条件：最多导出 10,000 条记录。',
  'withdrawLogs.export.limit.short': '导出最多 3 个月范围',

  // Withdraw Requests Page
  'withdrawRequests.page.table.column.automated': '自动化',
  'withdrawRequests.page.table.newAddress': '新地址',
  'withdrawRequests.page.table.status.PENDING': '待处理',
  'withdrawRequests.page.table.status.ACCEPTED': '已批准',
  'withdrawRequests.page.table.status.REJECTED': '已拒绝',
  'withdrawRequests.page.table.newAddressNoDeposit': '新地址 - 无历史充值记录',
};
